import { createAction, props } from '@ngrx/store';

import { DpuFileType } from '../dpu-file.type';

const SET_PATH = '[DPU File] Set Path';
const SET_APP_METADATA = '[DPU File] Set App Metadata';

const SAVE = '[DPU File] Save';
const SAVE_AS_WITH_AUTO_NAMING = '[DPU File] Save As With Auto Naming';
const SAVE_SETUP_IN_PERSISTENT_FILE = '[DPU File] Save Setup in Persistent File';
const SAVE_PERSISTENT_FILE_SUCCEEDED = '[DPU File] Save Persistent File Succeeded';
const SAVE_SUCCEEDED = '[DPU File] Save Succeeded';
const SAVE_FAILED = '[DPU File] Save Failed';
const RESTORE_SETUP_INFO = '[DPU File] Restore Setup Info';

const SCHEDULE_SHUTDOWN = '[App Event] Schedule Shutdown';

const setAppMetadata = createAction(
  SET_APP_METADATA,
  props<{ appMetadata: object }>(),
);

const setPath = createAction(
  SET_PATH,
  props<{ path: string }>(),
);

const save = createAction(
  SAVE,
  props<{ fileName: string, fileType: DpuFileType }>(),
);

const saveAsWithAutoNaming = createAction(
  SAVE_AS_WITH_AUTO_NAMING,
  props<{ fileType: DpuFileType }>(),
);

const saveSetupInPersistentFile = createAction(
  SAVE_SETUP_IN_PERSISTENT_FILE,
  props<{ shouldScheduleShutdown: boolean }>(),
);

const savePersistentFileSucceeded = createAction(
  SAVE_PERSISTENT_FILE_SUCCEEDED,
  props<{ path: string, shouldScheduleShutdown: boolean }>(),
);

const saveSucceeded = createAction(
  SAVE_SUCCEEDED,
  props<{ path: string, fileType: DpuFileType, fileName: string }>(),
);

const saveFailed = createAction(
  SAVE_FAILED,
  props<{ error: { code: number, message: string }, fileName: string }>(),
);

const restoreSetupInfo = createAction(
  RESTORE_SETUP_INFO,
);

const scheduleShutdown = createAction(
  SCHEDULE_SHUTDOWN,
  props<{ delayInSeconds: number }>(),
);

// Note: keep the "save" prefix to avoid conflicts.
//  Will be removed when all the dpu actions are moved to this module
export const SaveDpuFileActions = {
  setPath,
  setAppMetadata,
  save,
  saveAsWithAutoNaming,
  saveSetupInPersistentFile,
  savePersistentFileSucceeded,
  saveSucceeded,
  saveFailed,
  restoreSetupInfo,
  scheduleShutdown,
};
